// =======================================
//================== API FUNCTIONS =======
// =======================================

import {API_URL} from "./constants";

export function api_health_check(callback) {
    fetch(API_URL + '/health-check', {
        method: "GET",
        headers: {},
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            return false;
        }

    }).then(function (result) {

        if (result && result['health-check'])
            if (callback) callback(result);
            else if (callback) callback(false);

    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_login(data, callback) {
    let email = data.email;
    data = {'email': email, 'password': data.password};
    const params = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
    fetch(API_URL + '/user/login', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json; charset=utf-8'
        },
        body: params,
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();
            } else {
                if (callback) callback(false);
                return false;
            }
        })
        .then(function (result) {
            
            // if(result && result.token && result.employee.split(',').map(Number).includes(1)){
            if (result && result.token) {
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_recover_password(data, callback) {
    
    const params = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
    fetch(API_URL + '/user/recoveryPassword', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json; charset=utf-8'
        },
        body: params,
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result) {
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_me(data, callback) {
    fetch(API_URL + '/user/me/' + data.permissions, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    })
        .then(function (res) {
            return res.json();
        })
        .then(function (result) {
            if (callback) callback(result);
        })
        .catch(function (error) {
            
            if (callback) callback(false);
        });
}

export function api_token(data, callback) {
    data = {'refresh_token': data.refresh_token, 'id': data.id};
    const params = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');

    fetch(API_URL + '/user/token', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json; charset=utf-8'
        },
        body: params,
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();
            } else {
                if (callback) callback(false);
                return false;
            }

        })
        .then(function (result) {
            if (result && result.token) {
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_get_project_merchant(data, callback) {
    fetch(API_URL + '/photoselfie/project-merchant/' + data.idProject, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(res);
            return false;
        }
    }).then(function (result) {
        if (result.length > 0 && result[0].project_name) {
            if (callback) callback(result[0]);
        } else {
            if (callback) callback(result.result);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_metadata_by_projectID(data, callback) {
    
    fetch(API_URL + '/order/shop/' + data.project_id, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
    
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result) {
    
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_calendars(data, callback) {
    
    fetch(API_URL + '/photoselfie/calendars/' + data.idProject, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result) {
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_calendar_data(data, callback) {
    fetch(API_URL + '/photoselfie/calendar-data/' + data.idProject + "/" + data.idCalendar, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result) {
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}



export function api_get_calendar_data_project_id_calendar_id(data, callback) {
    fetch(API_URL + '/photoselfie/calendar/' + data.idProject + "/" + data.idCalendar, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result) {
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}





export function api_save_edited_calendar_data(data, callback) {
    
    fetch(API_URL + '/photoselfie/update-calendar-data/', {
        method: "POST",
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + data.token},
        body: JSON.stringify(data)
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
    
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_delete_calendar_by_id(data, callback) {
    
    fetch(API_URL + '/photoselfie/calendar' + data.idProject + "/" + data.idCalendar, {
        method: "POST",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result) {
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_landing_page_data_by_url(data, callback) {

    let params = {
        'url': data.url
    };
    
    params = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    fetch(API_URL + '/photoselfie/landing-page-data/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            // 'Authorization': 'Bearer ' + data.token,
        },
        body: params
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_project_configuration_data(data, callback) {
    
    fetch(API_URL + '/photoselfie/config-data/' + data.project_id, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result) {
            
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_data_sessione_scatti(data, callback) {
    
    fetch(API_URL + '/photoselfie/sessionescatti-data/' + data.project_id, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result) {
            
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_last_data_sessione_scatti(data, callback) {
    
    fetch(API_URL + '/photoselfie/last-sessionescatti-data/' + data.project_id + "/" + data.downloadDate, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
    
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result) {
    
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_save_project_data(data, callback) {


    let params = {
        'idProject': data.idProject,
        'project_name': data.project_name,
        'project_type': data.project_type,
        'merchant_email': data.merchant_email,
        'lang': data.lang,
        'url': data.url,
        'sendExcelToRef': data.sendExcelToRef,
        'state': data.state,
        'landingPageEnabled': data.landingPageEnabled
    };
    params = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    fetch(API_URL + '/photoselfie/saveProjectData/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_upload_excel_data(data, callback) {

    fetch(API_URL + '/photoselfie/save_excel_data/', {
        method: "POST",
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + data.token},
        body: JSON.stringify(data)
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_update_project_metadata(data, callback) {
    

    fetch(API_URL + '/photoselfie/update-project-metadata/', {
        method: "POST",
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + data.token},
        body: JSON.stringify(data)
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}





/**
 * salva i dati del form di Photo Selfie
 * versione prima della modalità multipla: invio del file e dei dati del form
 * 
 * @param {*} data 
 * @param {*} callback 
 */
export function api_save_athlete_data(data, callback) {

    const formData = new FormData();
    // const filename = data.photo.name;

    formData.append('category', data.category);
    formData.append('categoryID', data.categoryID);
    formData.append('is_referent', data.is_referent);
    formData.append('lastname', data.lastname);
    formData.append('name', data.name);

    formData.append('fileToUpload', data.photo);
    // formData.append('filename', filename);
    
    formData.append('photo_file_name', data.photo_file_name);
    formData.append('photo_file_size', data.photo_file_size);

    formData.append('photoID', data.photoID);    
    formData.append('projectID', data.projectID);
    formData.append('referent_mail', data.referent_mail);
    
    formData.append('team', data.team);
    formData.append('teamID', data.teamID);
    formData.append('upload_date', data.upload_date);

    
    const options = {
        method: 'POST',
        body: formData,
    };

    const apiUrl = API_URL + '/photoselfie/save_athlete_data/';
    
    fetch(apiUrl, options).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
    
}


/**
 * invia i dati del form di PhotoSelfie
 * @param {*} data 
 * @param {*} callback 
 */
export function api_save_multi_athlete_data(data, callback) {
    
    let params = {
        'is_referent':data.is_referent,
        'referent_mail':data.referent_mail,
        'ProjectID':data.ProjectID,
        'number_athletes':data.number_athletes,
        'photo_uploaded':JSON.stringify(data.photo_uploaded),
    };

    params = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            // 'Authorization': 'Bearer ' + data.token,
        },
        body: params
    };

    const apiUrl = API_URL + '/photoselfie/save_multi_athlete_data/';
    
    
    fetch(apiUrl, options).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
    
}


/**
 * invia foto e info dell'atleta al server API affinchè possa salvare il file su AWS
 * 
 * @param {*} data 
 * @param {*} callback 
 */
export function api_save_athlete_photo(data, callback) {

    const formData = new FormData();

    formData.append('category', data.category);
    formData.append('categoryID', data.categoryID);
    formData.append('is_referent', data.is_referent);
    formData.append('lastname', data.lastname);
    formData.append('name', data.name);
    
    formData.append('photoID', data.photoID);
    formData.append('projectID', data.ProjectID);
    formData.append('referent_mail', data.referent_mail);
    
    formData.append('team', data.team);
    formData.append('teamID', data.teamID);
    formData.append('upload_date', data.upload_date);

    formData.append('fileToUpload', data.fileToUpload);
    
    const options = {
        method: 'POST',
        body: formData,
    };

    let apiUrl = API_URL + '/photoselfie/save_athlete_photo/';
    
    // if(process.env.NODE_ENV==='development'){
    //     apiUrl = API_URL + '/photoselfie/save_athlete_photo2/';
    // } 
    
    fetch(apiUrl, options)
        .then(function (res) {

            return res.json();

        }).then(function (result) {
            
            if (callback) callback(result);
        }).catch(function (error) {
            
            if (callback) callback(false);
        });
    
}


/**
 * dato il nome del file la chimata API risponde con la url dal server S3 dove è stato appena caricato
 * ancora in sviluppo
 * problema la url risponde come se fosse un file xml, deve essere qualcosa legato con i permessi di amazon
 * serve un qualcosa per far capire al browser che si tratta di una immagine da mostrare in tag img
 * 
 * @param {*} data 
 * @param {*} callback 
 */
export function api_get_photoselfie_geturl(data, callback) {
    
    fetch(API_URL + '/photoselfie/geturl/' + data.idProject + '/'+ data.fileName, {
        method: "GET",
        headers: {
            // 'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            return false;
        }
    }).then(function (result) {
        
        if (callback) callback(result);
        
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

/**
 * usa la chiamata API save_athlete_photo2
 * che fa un giro diverso per salvare le foto in S3
 * ancora in fase di test
 * 
 * @param {*} data 
 * @param {*} callback 
 */
export function api_save_athlete_photo2(data, callback) {
    
    const formData = new FormData();

    formData.append('category', data.category);
    formData.append('categoryID', data.categoryID);
    formData.append('is_referent', data.is_referent);
    formData.append('lastname', data.lastname);
    formData.append('name', data.name);
    
    
    formData.append('photoID', data.photoID);
    
    formData.append('projectID', data.ProjectID);
    formData.append('referent_mail', data.referent_mail);
    
    formData.append('team', data.team);
    formData.append('teamID', data.teamID);
    formData.append('upload_date', data.upload_date);
    formData.append('fileToUpload', data.fileToUpload);
    

    
    const options = {
        method: 'POST',
        body: formData,
    };

    const apiUrl = API_URL + '/photoselfie/save_athlete_photo2/';
    
    fetch(apiUrl, options)
        .then(function (res) {
            
            return res.json();
        }).then(function (result) {
            
            if (callback) callback(result);
        }).catch(function (error) {
            
            if (callback) callback(false);
        });
    
}

export function api_check_newsletter_registration_new(data) {
    let params = Object.assign({}, data);
    delete params.token;
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/user/check_newsletter_registration', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
    }).then(function (res) {
        
        if (res.status === 200) {
            return res.json();
        } else {
            
            return false;
        }
    }).then(function (result) {
        
        if (result) {
            // console.log("ok");
        } else {
            // console.log("ko");
        }
    }).catch(function (error) {
        // console.log(error);
        // console.log("ko");
    });
}

export function api_update_download_data(data, callback) {
    
    fetch(API_URL + '/photoselfie/update-download-date/', {
        method: "POST",
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + data.token},
        body: JSON.stringify(data)
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_change_landing_page_data(data, callback) {
    
    fetch(API_URL + '/photoselfie/update-landing-page-status/', {
        method: "POST",
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + data.token},
        body: JSON.stringify(data)
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_delete_athlete(data, callback) {
    fetch(API_URL + '/photoselfie/delete-athlete/', {
        method: "POST",
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + data.token},
        body: JSON.stringify(data)
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_send_data_to_referents(data, callback) {
    fetch(API_URL + '/photoselfie/send-data-to-referents/', {
        method: "POST",
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + data.token},
        body: JSON.stringify(data)
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_search_users(data, callback) {
    let app_params = {
        'key': data.key,
        'page': data.page,
        'limit': data.limit,
        order: data.order,
        sort: data.sort,
        filter: data.filter,
        employee: data.employee,
        guest: data.guest && data.guest === 1 ? 1 : 0
    };
    const params = Object.keys(app_params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(app_params[key]);
    }).join('&');

    fetch(API_URL + '/user/search/' + data.page + '/?' + params, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();

            } else if (res.status === 404) {
                if (callback) callback({results: [], pages: 0})
                return false;
            } else {
                if (callback) callback(false);
                return false;
            }

        })
        .then(function (result) {
            if (result && result.results) {
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_get_projects_by_user(token, callback) {
    let app_params = {'token': token};
    const params = Object.keys(app_params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(app_params[key]);
    }).join('&');
    fetch(API_URL + '/permission/search/?' + params, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + token,
        },
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();

            } else if (res.status === 404) {
                if (callback) callback({results: [], pages: 0})
                return false;
            } else {
                if (callback) callback(false);
                return false;
            }
        })
        .then(function (result) {
            if (result && result.results) {
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_get_projects_by_id(data, callback) {
    let app_params = {'token': data.token, 'projectID': data.projectID};

    const params = Object.keys(app_params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(app_params[key]);
    }).join('&');
    fetch(API_URL + '/permission/search/?' + params, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();

            } else if (res.status === 404) {
                if (callback) callback({results: [], pages: 0})
                return false;
            } else {
                if (callback) callback(false);
                return false;
            }
        })
        .then(function (result) {
            if (result && result.results) {
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_add_user(data, callback) {
    let params = {
        'name': data.name,
        'surname': data.surname,
        'email': data.email,
        roles: data.roles_id,
        password: data.password
    };
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    fetch(API_URL + '/user/signup/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        //if(callback) callback(false);
    });
}

export function api_update_user(data, callback) {
    let params = Object.assign({}, data);
    delete params.token;
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/user/update', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params,
    }).then(function (res) {
        //if(res.status==200){
        return res.json();
        //}else{
        //    if(callback) callback(false);
        //    return false;
        //}
    }).then(function (result) {
        //if(result && result.updated){
        //    if(callback) callback(true);
        //}else{
        
        if (callback) callback(result);
        //}
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_update_user_phone(data, callback) {
    var params = {phone: data.phone};
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/user/updatePhone', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params,
    }).then(function (res) {
        
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result && result.updated) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_update_user_email(data, callback) {
    var params = {
        new_email: data.new_email, password: data.password, hello: data.hello, welcome: data.welcome,
        modify: data.modify, modify_click: data.modify_click, thank: data.thank, update: data.update
    };
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/user/updateEmail', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params,
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        
        if (result && result.success) {
            if (callback) callback(result);
        } else {
            if (callback) callback(result);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_search_roles(data, callback) {
    let app_params = {'key': data.key, 'page': data.page, 'limit': data.limit, employee: data.employee};
    const params = Object.keys(app_params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(app_params[key]);
    }).join('&');

    fetch(API_URL + '/role/search/?' + params, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();

            } else if (res.status === 404) {
                if (callback) callback({results: [], pages: 0})
                return false;
            } else {
                if (callback) callback(false);
                return false;
            }

        })
        .then(function (result) {
            if (result && result.results) {
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_delete_role(data, callback) {
    fetch(API_URL + '/role/delete/' + data.id + '/?employee=' + data.employee, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result && result.deleted) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_search_areas(data, callback) {
    var app_params = {'key': data.key, 'page': data.page, 'limit': data.limit, employee: data.employee};
    const params = Object.keys(app_params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(app_params[key]);
    }).join('&');

    fetch(API_URL + '/area/search/?' + params, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();

            } else if (res.status === 404) {
                if (callback) callback({results: [], pages: 0})
                return false;
            } else {
                if (callback) callback(false);
                return false;
            }

        })
        .then(function (result) {
            if (result && result.results) {
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_add_role(data, callback) {
    var params = {
        'name': data.name,
        'description': data.description,
        area_id: data.area_id,
        permissions: data.permissions
    };
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/role/add/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else if (res.status === 404) {
            if (callback) callback(false)
            return false;
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result) {
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_update_role(data, callback) {
    var params = Object.assign({}, data);
    delete params.token;
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    fetch(API_URL + '/role/update/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else if (res.status === 404) {
            if (callback) callback(false)
            return false;
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result && result.updated) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_update_permission(data, callback) {
    let id = data.id;
    let description = data.description;
    var params = {'id': id, description: description};
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/permission/update', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params,
    }).then(function (res) {
        
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result && result.updated) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_add_direct_permissions_to_user(data, callback) {
    var params = {'permissions': data.permissions, 'area_id': data.area_id, user_id: data.user_id};
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    fetch(API_URL + '/user/add/permissions', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else if (res.status === 404) {
            if (callback) callback(false)
            return false;
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result && result.add) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_delete_direct_user_permission(data, callback) {
    fetch(API_URL + '/user/permission/' + data.user_id + '/' + data.permission_id + '/' + data.area_id, {
        method: "DELETE",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result && result.deleted) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_add_shipment(data, callback) {
    var params = {country: data.country, price: data.price, order_total_to_get_free: data.order_total_to_get_free};
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/shipment/add', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params,
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result && (result.id || result.updated)) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_delete_shipment(data, callback) {
    fetch(API_URL + '/shipment/delete/' + data.id, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result && result.deleted) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_delete_promotion(data, callback) {
    fetch(API_URL + '/promotion/delete/' + data.id, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result && result.deleted) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_update_promotion(data, callback) {
    fetch(API_URL + '/promotion/update/' + data.id, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result && result.deleted) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_search_shipments(data, callback) {
    let app_params = {
        'key': data.key,
        'page': data.page,
        'limit': data.limit,
        order: data.order,
        sort: data.sort,
        filter: data.filter
    };
    const params = Object.keys(app_params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(app_params[key]);
    }).join('&');

    fetch(API_URL + '/shipment/search/' + data.page + '/?' + params, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();

            } else if (res.status === 404) {
                if (callback) callback({results: [], pages: 0})
                return false;
            } else {
                if (callback) callback(false);
                return false;
            }

        })
        .then(function (result) {
            if (result && result.results) {
                
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_add_promotion(data, callback) {
    var params = {
        name: data.name,
        discount_min_quantity: data.discount_min_quantity,
        discount_percentage: data.discount_percentage,
        id_stores: data.id_stores,
        products_ids: data.products_ids,
        start_date: data.start_date,
        end_date: data.end_date,
        type: data.type,
        all_stores: data.all_stores,
        all_products: data.all_products
    };
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/promotion/add', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params,
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (results) {
        if (results && results.id) {
            if (callback) callback(results.id);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_search_stores(data, callback) {
    var app_params = {
        'key': data.key,
        'page': data.page,
        'limit': data.limit,
        order: data.order,
        sort: data.sort,
        filter: data.filter,
        active: data.active
    };
    const params = Object.keys(app_params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(app_params[key]);
    }).join('&');

    fetch(API_URL + '/store/search/' + data.page + '/?' + params, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    })
        .then(function (res) {
            if (res.status === 200) {
                return res.json();

            } else if (res.status === 404) {
                if (callback) callback({results: [], pages: 0})
                return false;
            } else {
                if (callback) callback(false);
                return false;
            }

        })
        .then(function (result) {
            if (result && result.results) {
                if (callback) callback(result);
            } else {
                if (callback) callback(false);
            }
        })
        .catch(function (error) {
            if (callback) callback(false);
        });
}

export function api_get_user_addresses(data, callback) {
    fetch(API_URL + '/address/get/' + data.is_billing + '/', {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            return false;
        }
        //    if(callback) callback(false);

        //}
    }).then(function (result) {
        //if(result){
        
        if (callback) callback(result);
        // }else{
        //if(callback) callback(result);
        //}
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_user_pickup_addresses(data, callback) {
    fetch(API_URL + '/address/get/pdr/' + data.is_pickup_point + '/', {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            return false;
        }
    }).then(function (result) {
        //if(result){
        
        if (callback) callback(result);
        // }else{
        //if(callback) callback(result);
        //}
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_add_user_address(data, callback) {
    let params = data;
    let token = data.token;
    delete params.token;
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/address/add', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + token,
        },
        body: params,
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (result && result.id) {
            if (callback) callback(result);
        } else {
            if (callback) callback(result);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_update_user_address(data, callback) {
    var params = data;
    var token = data.token;
    delete params.token;
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/address/update', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + token,
        },
        body: params,
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (result && result.updated) {
            if (callback) callback(result);
        } else {
            if (callback) callback(result);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_delete_user_address(data, callback) {
    fetch(API_URL + '/address/delete/' + data.id, {
        method: "DELETE",
        headers: {
            //'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (result && result.deleted) {
            if (callback) callback(true);
        } else {
            if (callback) callback(result);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_set_default_user_address(data, callback) {
    var params = data;
    var token = data.token;
    delete params.token;
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/address/default', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + token,
        },
        body: params,
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (result && result.updated) {
            if (callback) callback(true);
        } else {
            if (callback) callback(result);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_send_billing_user_sms(data, callback) {
    var params = {type: data.type, numbers: data.numbers};
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/billing/send-sms/' + data.user_id, {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params,
    }).then(function (res) {
        if (res.status === 200)
            return res.json();
        return false;

    }).then(function (results) {
        if (results) {
            if (callback) callback(true);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        
        if (callback) callback(false);
    });
}

export function api_get_orders(data, callback) {
    fetch(API_URL + '/order/get/' + data.project_id, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            return false;
        }
    }).then(function (result) {
        //if(result){
        if (callback) callback(result);
        // }else{
        //if(callback) callback(result);
        //}
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_set_sessione_scatti(data, callback) {
    
    fetch(API_URL + '/order/shop/' + data.project_id, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result) {
            
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_stack_by_user(data, callback) {
    fetch(API_URL + '/user/stack/', {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result) {
            
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_coupon_by_user(data, callback) {
    fetch(API_URL + '/user/coupons/', {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }

    }).then(function (result) {
        if (result) {
            
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_create_Coupon(data, callback) {
    let params = data;
    let token = data.token;
    delete params.token;
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/user/coupon', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + token,
        },
        body: params,
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            return false;
        }
    }).then(function (result) {
        if (result) {
            
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_login_as_user(data, callback) {
    var params = data;
    var token = data.token;
    delete params.token;
    params = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    fetch(API_URL + '/user/get/login', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + token,
        },
        body: params,
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            return false;
        }
    }).then(function (result) {
        if (result) {
            
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_save_calendar_data(data, callback) {
    

    let params = {
        'calendar_id':data.calendar_id,
        'projectID': data.projectID,
        'calendar_name': data.calendar_name,
        'calendar_language': data.calendar_language,
        'calendar_landing_page_url': data.calendar_landing_page_url
    };

    params = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    fetch(API_URL + '/photoselfie/save-calendar-data/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + data.token,
        },
        body: params
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_upload_calendar_data(data, callback) {
    
    let final_calendar_data = {};

    final_calendar_data.project_id = data.project_id;
    final_calendar_data.cal_id = data.cal_id;
    final_calendar_data.cal_name = data.cal_name;
    final_calendar_data.logo_file_name = data.calendar_logo ? data.calendar_logo.file.name : '';

    if (data.calendar_logo) {
        data['logo_file_name'] = data.calendar_logo.file.name;
        delete data.calendar_logo;
    }

    data.months.forEach((month) => {
        const month_data = data[`${month}`];
        final_calendar_data[`${month}`] = {};
        final_calendar_data[`${month}`].title = month_data.calendar_name.length > 0 ? month_data.calendar_name : '';
        final_calendar_data[`${month}`].description = month_data.description.length > 0 ? month_data.description : '';
        final_calendar_data[`${month}`].photo_names = [];
        final_calendar_data[`${month}`].sponsor_1 = '';
        final_calendar_data[`${month}`].sponsor_2 = '';

        if (month_data.photos.length > 0) {
            if (month_data.photos && month_data.photos.length > 0) {
                month_data.photos.forEach((photo) => {
                    final_calendar_data[`${month}`].photo_names.push(photo.file.name);
                });
            }
        }

        if (month_data.sponsor_1.file) {
            final_calendar_data[`${month}`].sponsor_1 = month_data.sponsor_1.file.name;
        }

        if (month_data.sponsor_2.file) {
            final_calendar_data[`${month}`].sponsor_2 = month_data.sponsor_2.file.name;
        }

        if (month_data.calendar_logo) {
            data['logo_file_name'] = month_data.calendar_logo.file.name;
        }
    })


    const formData = new FormData();
    formData.append('project_id', final_calendar_data.project_id);
    formData.append('cal_id', final_calendar_data.cal_id);
    formData.append('cal_name', final_calendar_data.cal_name);
    formData.append('logo_file_name', final_calendar_data.logo_file_name);

    formData.append('january', JSON.stringify(final_calendar_data.january));
    formData.append('february', JSON.stringify(final_calendar_data.february));
    formData.append('march', JSON.stringify(final_calendar_data.march));
    formData.append('april', JSON.stringify(final_calendar_data.april));
    formData.append('may', JSON.stringify(final_calendar_data.may));
    formData.append('june', JSON.stringify(final_calendar_data.june));

    formData.append('july', JSON.stringify(final_calendar_data.july));
    formData.append('august', JSON.stringify(final_calendar_data.august));
    formData.append('september', JSON.stringify(final_calendar_data.september));
    formData.append('october', JSON.stringify(final_calendar_data.october));
    formData.append('november', JSON.stringify(final_calendar_data.november));
    formData.append('december', JSON.stringify(final_calendar_data.december));

    

    const apiUrl = API_URL + '/photoselfie/upload-calendar-data/';
    // const apiUrl = API_URL + '/photoselfie/upload-calendar-data-test/';

    const options = {
        method: 'POST',
        body: formData,
    };

    fetch(apiUrl, options).then(function (res) {
        return res.json();
    }).then(function (result) {
        
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_upload_photo(data, callback) {

    const formData = new FormData();

    formData.append('project_id', data.project_id);
    formData.append('cal_id', data.cal_id);
    formData.append('cal_type', data.cal_type);
    formData.append('cal_month', data.cal_month);
    formData.append('fileToUpload', data.file);

    const options = {
        method: 'POST',
        body: formData,
    };

    const apiUrl = API_URL + '/photoselfie/upload-photo/';
    
    fetch(apiUrl , options).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_calendar_landing_page_data_by_url(data, callback) {
    
    let params = {
        'url': data.url
    };
    params = Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    fetch(API_URL + '/photoselfie/calendar_landing-page-data/', {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params
    }).then(function (res) {
        return res.json();
    }).then(function (result) {
        if (callback) callback(result);
    }).catch(function (error) {
        if (callback) callback(false);
    });
}

export function api_get_project_teams(data, callback) {
    fetch(API_URL + '/photoselfie/project-teams/' + data.idProject, {
        method: "GET", headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            return false;
        }
    }).then(function (result) {
        if (callback) callback(result);

    }).catch(function (error) {
        if (callback) callback(false);
    });
}


// WEBPACK FOOTER //
// ./src/utils/API.js